import File from '@/classes/case/File'

class Document {
  constructor (title, files) {
    this.title = title
    this.files = files
  }

  static asDocuments (json) {
    return json.map(document => {
      return Document.asDocument(document)
    })
  }

  static asDocument (json) {
    return new Document(
      json.title,
      json.files ? File.asFiles(json.files) : []
    )
  }
}

export {
  Document
}
